var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebhook3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_8489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H49V49H0V0Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.153125 0H0V0.153125H0.153125V0Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 32.1562H13.7812V33.6875H35.2188V32.1562ZM35.2188 33.6875H13.7812V35.2188H35.2188V33.6875ZM35.2188 35.2188H13.7812V36.75H35.2188V35.2188ZM35.2188 36.75H13.7812V38.2812H35.2188V36.75ZM16.8438 38.2812H13.7812V39.8125H16.8438V38.2812ZM35.2188 38.2812H18.375V39.8125H35.2188V38.2812ZM16.8438 39.8125H13.7812V41.3438H16.8438V39.8125ZM35.2188 39.8125H18.375V41.3438H35.2188V39.8125ZM16.8438 41.3438H13.7812V42.875H16.8438V41.3438ZM35.2188 41.3438H18.375V42.875H35.2188V41.3438ZM16.8438 42.875H13.7812V44.4062H16.8438V42.875ZM35.2188 42.875H18.375V44.4062H35.2188V42.875ZM16.8438 44.4062H13.7812V45.9375H16.8438V44.4062ZM35.2188 44.4062H18.375V45.9375H35.2188V44.4062ZM16.8438 45.9375H13.7812V47.4688H16.8438V45.9375ZM35.2188 45.9375H18.375V47.4688H35.2188V45.9375ZM16.8438 47.4688H13.7812V49H16.8438V47.4688ZM35.2188 47.4688H18.375V49H35.2188V47.4688Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 36.75H21.4375V38.2812H27.5625V36.75ZM24.5 38.2812H21.4375V39.8125H24.5V38.2812Z",
    fill: "#343235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 38.2812H24.5V39.8125H27.5625V38.2812Z",
    fill: "#E5E5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 39.8125H21.4375V41.3438H24.5V39.8125Z",
    fill: "#343235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 39.8125H24.5V41.3438H27.5625V39.8125ZM27.5625 41.3438H21.4375V42.875H27.5625V41.3438Z",
    fill: "#E5E5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 6.125H16.8438V7.65625H21.4375V6.125Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 6.125H29.0938V7.65625H33.6875V6.125Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 7.65625H15.3125V9.1875H22.9688V7.65625Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 7.65625H27.5625V9.1875H35.2188V7.65625Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 9.1875H15.3125V10.7188H22.9688V9.1875Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 9.1875H27.5625V10.7188H35.2188V9.1875ZM16.8438 10.7188H12.25V12.25H16.8438V10.7188Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.7188H16.8438V12.25H24.5V10.7188Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 10.7188H26.0312V12.25H35.2188V10.7188Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 10.7188H35.2188V12.25H38.2812V10.7188Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 12.25H10.7188V13.7812H16.8438V12.25Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 12.25H16.8438V13.7812H26.0312V12.25Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1562 12.25H26.0312V13.7812H32.1562V12.25Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 12.25H32.1562V13.7812H39.8125V12.25Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 13.7812H10.7188V15.3125H18.375V13.7812Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 13.7812H18.375V15.3125H26.0312V13.7812Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 13.7812H26.0312V15.3125H30.625V13.7812Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 13.7812H30.625V15.3125H39.8125V13.7812Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 15.3125H10.7188V16.8438H19.9062V15.3125Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 15.3125H19.9062V16.8438H21.4375V15.3125Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.3125H21.4375V16.8438H24.5V15.3125Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 15.3125H24.5V16.8438H29.0938V15.3125Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 15.3125H29.0938V16.8438H30.625V15.3125Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 15.3125H30.625V16.8438H39.8125V15.3125Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 16.8438H12.25V18.375H21.4375V16.8438Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 16.8438H21.4375V18.375H22.9688V16.8438Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.8438H22.9688V18.375H24.5V16.8438Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 16.8438H24.5V18.375H27.5625V16.8438Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 16.8438H27.5625V18.375H29.0938V16.8438Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 16.8438H29.0938V18.375H38.2812V16.8438Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.375H15.3125V19.9062H22.9688V18.375Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.375H22.9688V19.9062H24.5V18.375Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 18.375H24.5V19.9062H26.0312V18.375Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 18.375H26.0312V19.9062H27.5625V18.375Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 18.375H27.5625V19.9062H35.2188V18.375ZM19.9062 19.9062H16.8438V21.4375H19.9062V19.9062Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.9062H19.9062V21.4375H24.5V19.9062Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 19.9062H24.5V21.4375H26.0312V19.9062Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 19.9062H26.0312V21.4375H30.625V19.9062Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 19.9062H30.625V21.4375H33.6875V19.9062ZM22.9688 21.4375H15.3125V22.9688H22.9688V21.4375Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.4375H22.9688V22.9688H24.5V21.4375Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 21.4375H24.5V22.9688H26.0312V21.4375Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 21.4375H26.0312V22.9688H27.5625V21.4375Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 21.4375H27.5625V22.9688H35.2188V21.4375Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 22.9688H12.25V24.5H21.4375V22.9688Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 22.9688H21.4375V24.5H22.9688V22.9688Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 22.9688H22.9688V24.5H26.0312V22.9688Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 22.9688H26.0312V24.5H27.5625V22.9688Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 22.9688H27.5625V24.5H29.0938V22.9688Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 22.9688H29.0938V24.5H38.2812V22.9688Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 24.5H10.7188V26.0312H19.9062V24.5Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 24.5H19.9062V26.0312H21.4375V24.5Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 24.5H21.4375V26.0312H26.0312V24.5Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 24.5H26.0312V26.0312H29.0938V24.5Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 24.5H29.0938V26.0312H30.625V24.5Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 24.5H30.625V26.0312H39.8125V24.5Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 26.0312H10.7188V27.5625H19.9062V26.0312Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26.0312H19.9062V27.5625H24.5V26.0312Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1562 26.0312H24.5V27.5625H32.1562V26.0312Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 26.0312H32.1562V27.5625H39.8125V26.0312Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 27.5625H10.7188V29.0938H18.375V27.5625Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.5625H18.375V29.0938H24.5V27.5625Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 27.5625H24.5V29.0938H26.0312V27.5625Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 27.5625H26.0312V29.0938H33.6875V27.5625Z",
    fill: "#0B5027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 27.5625H33.6875V29.0938H39.8125V27.5625Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4062 27.5625H41.3438V29.0938H44.4062V27.5625Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 29.0938H12.25V30.625H15.3125V29.0938Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 29.0938H15.3125V30.625H24.5V29.0938Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 29.0938H24.5V30.625H26.0312V29.0938Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 29.0938H26.0312V30.625H33.6875V29.0938Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 29.0938H33.6875V30.625H38.2812V29.0938Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4062 29.0938H38.2812V30.625H44.4062V29.0938Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 30.625H15.3125V32.1562H22.9688V30.625Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 30.625H22.9688V32.1562H27.5625V30.625Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 30.625H27.5625V32.1562H35.2188V30.625Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.875 30.625H35.2188V32.1562H42.875V30.625Z",
    fill: "#068940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 32.1562H15.3125V33.6875H22.9688V32.1562Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 32.1562H27.5625V33.6875H35.2188V32.1562Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 33.6875H16.8438V35.2188H21.4375V33.6875Z",
    fill: "#4BEA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 33.6875H29.0938V35.2188H33.6875V33.6875Z",
    fill: "#34AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.8438H15.3125V18.375H24.5V16.8438ZM35.2188 16.8438H26.0312V18.375H35.2188V16.8438ZM16.8438 18.375H15.3125V19.9062H16.8438V18.375Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 18.375H16.8438V19.9062H19.9062V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.375H19.9062V19.9062H22.9688V18.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.375H22.9688V19.9062H24.5V18.375ZM27.5625 18.375H26.0312V19.9062H27.5625V18.375Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 18.375H27.5625V19.9062H30.625V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 18.375H30.625V19.9062H33.6875V18.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 18.375H33.6875V19.9062H35.2188V18.375ZM16.8438 19.9062H10.7188V21.4375H16.8438V19.9062Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 19.9062H16.8438V21.4375H19.9062V19.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 19.9062H19.9062V21.4375H22.9688V19.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 19.9062H22.9688V21.4375H27.5625V19.9062Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 19.9062H27.5625V21.4375H30.625V19.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 19.9062H30.625V21.4375H33.6875V19.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 19.9062H33.6875V21.4375H35.2188V19.9062ZM12.25 21.4375H10.7188V22.9688H12.25V21.4375ZM16.8438 21.4375H15.3125V22.9688H16.8438V21.4375Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 21.4375H16.8438V22.9688H19.9062V21.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 21.4375H19.9062V22.9688H22.9688V21.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.4375H22.9688V22.9688H24.5V21.4375ZM27.5625 21.4375H26.0312V22.9688H27.5625V21.4375Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 21.4375H27.5625V22.9688H30.625V21.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 21.4375H30.625V22.9688H33.6875V21.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 21.4375H33.6875V22.9688H35.2188V21.4375ZM12.25 22.9688H10.7188V24.5H12.25V22.9688ZM16.8438 22.9688H15.3125V24.5H16.8438V22.9688Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 22.9688H16.8438V24.5H19.9062V22.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 22.9688H19.9062V24.5H22.9688V22.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.9688H22.9688V24.5H24.5V22.9688ZM27.5625 22.9688H26.0312V24.5H27.5625V22.9688Z",
    fill: "#00A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 22.9688H27.5625V24.5H30.625V22.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 22.9688H30.625V24.5H33.6875V22.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 22.9688H33.6875V24.5H35.2188V22.9688ZM24.5 24.5H15.3125V26.0312H24.5V24.5ZM35.2188 24.5H26.0312V26.0312H35.2188V24.5Z",
    fill: "#00A556"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_8489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhook3);
export default __webpack_public_path__ + "static/media/webhook3.de881ca2c877c083b3a12b5eebdfa294.svg";
export { ForwardRef as ReactComponent };